import React from 'react';
import useFadeIn from '../hooks/useFadeIn';
import valueProps from '../data/valueProps';

export default function WhyPramaan() {
  const [ref, visible] = useFadeIn(0.1);

  return (
    <section className="why-section" aria-label="Why Pramaan">
      <div className="section-inner">
        <div ref={ref} className={`why-header fade-up ${visible ? 'visible' : ''}`}>
          <div>
            <span className="section-eyebrow">Why Pramaan</span>
            <h2 className="section-title">
              Most signing tools<br />stop at the signature.
            </h2>
          </div>
          <p className="why-header-desc">
            Pramaan focuses on what happens after — identity verification,
            a tamper-evident record, and a complete chain of custody on
            every document you send.
          </p>
        </div>

        <div className="why-list" role="list">
          {valueProps.map(({ Icon, title, desc }, i) => (
            <div key={title} className="why-row" role="listitem">
              <span className="why-num">0{i + 1}</span>
              <div>
                <div className="why-title">{title}</div>
              </div>
              <p className="why-desc">{desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
